import { RootState } from "redux/reducers/rootReducer";
import { availableStorage } from "utils/storage";
import { getUserAgent } from "utils/userAgent";
export const CHECK_AGE_GATE = "ageGate/CHECK_AGE_GATE";
export type CheckAgeGateAction = {
  type: typeof CHECK_AGE_GATE;
  countryCode: string;
  currentUrl: string;
  queryString: string;
  storage: false | Storage;
  userAgent: string;
};

export const createCheckAgeGate = (state: RootState): CheckAgeGateAction => ({
  countryCode: state.config.domainCountryCode,
  currentUrl: window?.location?.pathname,
  queryString: window?.location?.search || "",
  storage: availableStorage(),
  type: CHECK_AGE_GATE,
  userAgent: getUserAgent(),
});

export const ACCEPT_AGE_GATE = "ageGate/ACCEPT_AGE_GATE";
export type AcceptAgeGateAction = {
  type: typeof ACCEPT_AGE_GATE;
  countryCode: string;
  rememberUser: boolean;
  storage: false | Storage;
};

export const createAcceptAgeGate = (
  rememberUser: boolean,
  state: RootState
): AcceptAgeGateAction => ({
  countryCode: state.config.domainCountryCode,
  rememberUser,
  storage: availableStorage(),
  type: ACCEPT_AGE_GATE,
});
